export const EditUserProfileMessage = {
    USER_CHANGES_SAVED: 'User changes have been successfully saved.',
} as const;
